export const CREATE_PRICE_BAND_NOTIFICATION = {
  SUCCESS: 'Price band created successfully',
  PARTIAL: 'Price band created with partial failure',
  ERROR: 'Something went wrong whilst creating a price band',
};

export const UPDATE_PRICE_BAND_NOTIFICATION = {
  SUCCESS: 'Price band updated successfully',
  PARTIAL: 'Price band updated with partial failure',
  ERROR: 'Something went wrong whilst updating a price band',
};
